import { Flex, Text } from "@paguelofacil/pf-components";

export const HeaderPayment = ({ title }) => {
    return (
        <Flex>
            <Text variant="body4" className="title-card-payment">
                {title}
            </Text>
        </Flex>
    );
};
